import { ApolloLink } from '@apollo/client';
import { getToken } from '~/helpers/token';

const authLink = (request?: Request) =>
    new ApolloLink((operation, forward) => {
        const context = operation.getContext();

        const token = getToken(request);

        operation.setContext({
            ...context,
            headers: {
                ...context.headers,
                ...(token && { Authorization: `Bearer ${token}` }),
            },
        });
        return forward(operation);
    });

export default authLink;
